// src/utils/textareaDialogService.ts
import React from "react";
import ReactDOM from "react-dom/client";
import TextareaModal from "./TextareaModal";

class TextareaDialogService {
  private container: HTMLDivElement | null = null;
  private root: ReactDOM.Root | null = null;

  private createContainer(): ReactDOM.Root {
    if (!this.container) {
      this.container = document.createElement("div");
      this.container.id = "textarea-modal-root";
      document.body.appendChild(this.container);
      this.root = ReactDOM.createRoot(this.container);
    }
    return this.root!;
  }

  private removeContainer(): void {
    if (this.container && this.root) {
      this.root.unmount();
      this.container.remove();
      this.container = null;
      this.root = null;
    }
  }

  async show(
    title: string = "Message",
    placeholder: string = "Type your message here...",
    confirmButtonText: string = "Submit",
    cancelButtonText: string = "Cancel"
  ): Promise<string | null> {
    return new Promise((resolve) => {
      const root = this.createContainer();

      const handleClose = (): void => {
        this.removeContainer();
        resolve(null);
      };

      const handleConfirm = (text: string): void => {
        this.removeContainer();
        resolve(text);
      };

      // Use React.createElement instead of calling the component as a function
      root.render(
        React.createElement(TextareaModal, {
          isOpen: true,
          onClose: handleClose,
          onConfirm: handleConfirm,
          title,
          placeholder,
          confirmButtonText,
          cancelButtonText,
        })
      );
    });
  }
}

export const textareaDialogService = new TextareaDialogService();
